import { apiGet, apiPost, apiPatch, apiDelete } from "../../shared/http.js";
import {
  ShoppingListResponseSchema,
  ShoppingListsResponseSchema,
  ItemCatalogResponseSchema,
  CreateShoppingListRequestSchema,
  PatchShoppingListRequestSchema,
  AddShoppingListItemRequestSchema,
  PatchShoppingListItemRequestSchema,
  type ShoppingListApiItem,
  type ShoppingListsResponse,
  type CreateShoppingListRequest,
  type PatchShoppingListRequest,
  type AddShoppingListItemRequest,
  type PatchShoppingListItemRequest,
} from "@recipevault/shared";

interface ListOpts {
  updatedSince?: string;
  cursor?: string;
  status?: string;
}

export async function listShoppingLists(opts: ListOpts = {}): Promise<ShoppingListsResponse> {
  const qs = new URLSearchParams();
  if (opts.updatedSince) qs.set("updatedSince", opts.updatedSince);
  if (opts.cursor) qs.set("cursor", opts.cursor);
  if (opts.status) qs.set("status", opts.status);
  const raw = await apiGet<unknown>(qs.toString() ? `/shopping-lists?${qs}` : "/shopping-lists");
  return ShoppingListsResponseSchema.parse(raw);
}

export async function createShoppingList(
  body: CreateShoppingListRequest,
  idempotencyKey: string,
): Promise<ShoppingListApiItem> {
  CreateShoppingListRequestSchema.parse(body);
  return ShoppingListResponseSchema.parse(
    await apiPost<unknown>("/shopping-lists", body, { idempotencyKey }),
  ).list;
}

export async function getShoppingList(id: string): Promise<ShoppingListApiItem> {
  return ShoppingListResponseSchema.parse(await apiGet<unknown>(`/shopping-lists/${id}`)).list;
}

export async function patchShoppingList(
  id: string,
  body: PatchShoppingListRequest,
): Promise<ShoppingListApiItem> {
  PatchShoppingListRequestSchema.parse(body);
  return ShoppingListResponseSchema.parse(
    await apiPatch<unknown>(`/shopping-lists/${id}`, body),
  ).list;
}

export async function deleteShoppingList(id: string): Promise<void> {
  await apiDelete(`/shopping-lists/${id}`);
}

export async function addShoppingListItem(
  id: string,
  body: AddShoppingListItemRequest,
  idempotencyKey: string,
): Promise<ShoppingListApiItem> {
  AddShoppingListItemRequestSchema.parse(body);
  return ShoppingListResponseSchema.parse(
    await apiPost<unknown>(`/shopping-lists/${id}/items`, body, { idempotencyKey }),
  ).list;
}

export async function patchShoppingListItem(
  id: string,
  itemId: string,
  body: PatchShoppingListItemRequest,
): Promise<ShoppingListApiItem> {
  PatchShoppingListItemRequestSchema.parse(body);
  return ShoppingListResponseSchema.parse(
    await apiPatch<unknown>(`/shopping-lists/${id}/items/${itemId}`, body),
  ).list;
}

export async function deleteShoppingListItem(
  id: string,
  itemId: string,
): Promise<ShoppingListApiItem> {
  return ShoppingListResponseSchema.parse(
    await apiDelete<unknown>(`/shopping-lists/${id}/items/${itemId}`),
  ).list;
}

export async function listShoppingCatalog(
  opts: { updatedSince?: string; cursor?: string } = {},
) {
  const qs = new URLSearchParams();
  if (opts.updatedSince) qs.set("updatedSince", opts.updatedSince);
  if (opts.cursor) qs.set("cursor", opts.cursor);
  const raw = await apiGet<unknown>(
    qs.toString() ? `/shopping-catalog?${qs}` : "/shopping-catalog",
  );
  return ItemCatalogResponseSchema.parse(raw);
}
